var map = {
	"./de.json": "6ce2",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fr.json": "f693",
	"./it.json": "0825",
	"./nl.json": "a625",
	"./pl.json": "89b2",
	"./pt.json": "5d67",
	"./sr.json": "081a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";